import React from 'react'
import {
  Button,
  ButtonActionBar,
  Comments,
  DeleteSelectionButton,
  DropdownMenu,
  FavouriteIcon,
  FavouriteSelect,
  References,
  /*TableSettingsModal,*/ Typography,
} from 'modules/core/components'
import { /*COLUMNS,*/ TABLES } from 'modules/core/constants'
// import { formItemsHelper } from "modules/core/utils";
import {
  DownloadOutlined,
  CommentOutlined,
  DollarOutlined,
  ControlOutlined,
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { Space } from 'antd'
import _ from 'lodash'

const TableActions = ({
  // setTableSettings,
  // tableSettings,
  // columns,
  onClickDownloadSpreadsheets,
  onClickDownload,
  dataDelete,
  disabled,
  onConfirmDelete,
  isDeleting,
  onClickSaveFav,
  visibleFav,
  onClickSave,
  onClickCancelSaveFav,
  setFavouriteName,
  favouriteName,
  isLoading,
  hasFavourite = false,
  options = [],
  canSave,
  viewSelect = undefined,
  setViewSelect,
  alreadyExist = false,
  layoutLoading,
  setPrimary,
  onClickDeleteFav,
  showComments,
  hasComment,
  setHasComment,
  setViewComment,
  userDetail,
  settings,
  setDataComments,
  comments,
  onRefetchComments,
  loading,
  onCommentCreate,
  removeNewComment,
  currencyData,
  onDownloadExcel = () => {},
  onDownloadParquet = () => {},
  onClickEditNameFav,
  onClckPreferences,
}) => {
  const enabledDeleteTransaction = true
  const { t } = useTranslation()

  const dowload = {
    spreadsheets: onClickDownloadSpreadsheets,
    file: onClickDownload,
    excel: onDownloadExcel,
    parquet: onDownloadParquet,
  }

  return (
    <ButtonActionBar position="space-between">
      <Space>
        <References
          referencesItems={[
            {
              color: '',
              type: '123',
              title: t('LABEL_TYPE_VALUES_REFERENCE', {
                type: settings.aggregatorName?.toLowerCase() || t('FIELD_DECIMALS').toLowerCase(),
              }),
            },
            ...(currencyData
              ? [
                  {
                    type: <DollarOutlined />,
                    title: currencyData && currencyData.code,
                    description:
                      currencyData &&
                      t('REFERENCE_DESCRIPTION', {
                        currencyName: t(currencyData.name).toLowerCase(),
                      }),
                  },
                ]
              : []),
          ]}
        />
        {enabledDeleteTransaction && !_.isEmpty(dataDelete) && (
          <DeleteSelectionButton
            onConfirm={onConfirmDelete}
            disabled={disabled}
            isDeletingAll={isDeleting}
          />
        )}
      </Space>
      <Space direction="horizontal">
        {canSave && (
          <FavouriteIcon
            visible={visibleFav}
            favouriteName={favouriteName}
            setFavouriteName={setFavouriteName}
            onClickCancelSaveFav={onClickCancelSaveFav}
            onClickSave={onClickSave}
            loading={isLoading}
            alreadyExist={alreadyExist}
            onClickSaveFav={onClickSaveFav}
            options={options}
          />
        )}
        {hasFavourite && (
          <FavouriteSelect
            viewSelect={viewSelect}
            loading={layoutLoading}
            options={options}
            setPrimary={setPrimary}
            setViewSelect={setViewSelect}
            onClickDeleteFav={onClickDeleteFav}
            onClickEditNameFav={onClickEditNameFav}
          />
        )}
        {showComments && (
          <Comments
            hasComment={hasComment.table}
            onClick={(visible) => {
              setHasComment({ type: 'table', data: visible })
              !visible && removeNewComment()
              !visible && setViewComment(visible)
            }}
            comments={comments}
            setData={setDataComments}
            loading={loading}
            onRefetchComments={onRefetchComments}
            onCommentCreate={onCommentCreate}
            onCleanHasComment={() => {
              setHasComment({ type: 'table', data: false })
              setViewComment(false)
            }}
          >
            <Typography.Icon
              style={{ cursor: 'pointer' }}
              title={t('LABEL_COMMENTS')}
              icon={CommentOutlined}
            />
          </Comments>
        )}
        <DropdownMenu
          title={t('ACTION_DOWNLOAD_TABLE')}
          placement="bottomRight"
          icon={<Typography.Icon icon={DownloadOutlined} />}
          menu={TABLES.OPTIONS_DOWNLOAD_ALL.map((formatType) => {
            return {
              title: formatType.name,
              key: formatType.id,
              onClick: dowload[formatType.id],
            }
          })}
        />
        <Button.Icon
          title="Preferencias"
          icon={<Typography.Icon icon={ControlOutlined} />}
          onClick={onClckPreferences}
        />
        {/* <TableSettingsModal
                    onConfirm={setTableSettings}
                    options={columns.filter(
                        (column, index) =>
                        !column.is_transaction &&
                        index !== COLUMNS.FIRST_INDEX &&
                        column.data_index !== COLUMNS.TOTAL_DATA_INDEX
                    )}
                    settings={tableSettings}
                    formItems={formItemsHelper.itemsDataView(
                        tableSettings.negativeValuesType,
                        tableSettings.showNegativeInRed
                    )}
                /> */}
      </Space>
    </ButtonActionBar>
  )
}

export default TableActions
